import React from 'react';
import { connect } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import Ax from "../../../components/hoc/Ax";
import Loader from "../../../components/ui/Loader/Loader";
import moment from 'moment';
import { Helmet } from 'react-helmet';
import Status from '../../../components/ui/Status';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';

class ItemDetailsTab extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            item_id: props.item_enc_id || null,
            refreshDetail: props.refreshDetail || false,
            itemData: null,
            details_loading: false
        };
    }

    componentDidMount() {
        if (this.props.item_enc_id) {
            this.getItemDetails(this.props.item_enc_id);
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (
    //         prevProps.item_enc_id !== this.props.item_enc_id ||
    //         this.props.refreshDetail === true
    //     ) {
    //         this.setState(
    //             {
    //                 item_id: this.props.item_enc_id,
    //                 refreshDetail: this.props.refreshDetail
    //             },
    //             () => {
    //                 this.getItemDetails(this.props.item_enc_id);
    //             }
    //         );
    //     }
    // }

    componentDidUpdate(prevProps) {
        // Case 1: Item ID changed - definitely need to fetch new data
        if (prevProps.item_enc_id !== this.props.item_enc_id) {
            this.setState(
                {
                    item_id: this.props.item_enc_id,
                    refreshDetail: false, // Reset the refresh flag
                    itemData: null // Clear old data
                },
                () => {
                    this.getItemDetails(this.props.item_enc_id);
                }
            );
        }
        // Case 2: Refresh requested AND we're not already loading
        else if (
            this.props.refreshDetail === true &&
            prevProps.refreshDetail !== this.props.refreshDetail &&
            !this.state.details_loading
        ) {
            // Store the fact that we're refreshing
            this.setState({ details_loading: true }, () => {
                this.getItemDetails(this.props.item_enc_id);
            });
        }
    }

    getItemDetails = (id) => {
    if (!id) return;

    this.setState({ details_loading: true });

    HttpAPICall.withAthorization(
        'GET',
        INVENTORY_API_BASE_URL_2 + '/item/' + id,
        this.props.access_token,
        { opening_stock: "Y" },
        {},
        (resp) => {
            let itemData = resp?.data?.data || null;

            if (this.props.itemDetailHandle) {
                this.props.itemDetailHandle(itemData);
            }

            this.setState({ itemData });
            
            // IMPORTANT: After successful fetch, notify parent to reset refreshDetail
            if (this.props.onRefreshComplete) {
                this.props.onRefreshComplete();
            }
        }
    ).finally(() => {
        this.setState({ details_loading: false });
    });
};

    // getItemDetails = (id) => {
    //     if (!id) return;

    //     this.setState({ details_loading: true });

    //     HttpAPICall.withAthorization(
    //         'GET',
    //         INVENTORY_API_BASE_URL_2 + '/item/' + id,
    //         this.props.access_token,
    //         { opening_stock: "Y" },
    //         {},
    //         (resp) => {
    //             let itemData = resp?.data?.data || null;

    //             if (this.props.itemDetailHandle) {
    //                 this.props.itemDetailHandle(itemData);
    //             }

    //             this.setState({ itemData });
    //         }
    //     ).finally(() => {
    //         this.setState({ details_loading: false });
    //     });
    // };

    render() {
        const { itemData, details_loading } = this.state;
        const { hideHelmet } = this.props; // Add this prop

        return (
            <section>
                {/* Conditionally render Helmet */}
                {!hideHelmet && <Helmet><title>Item Details</title></Helmet>}

                <div className="row ml1">
                    <div className="col-12 pl0 bg-white">
                        {details_loading ? (
                            <Loader />
                        ) : itemData ? (
                            <div className='m-2'>
                                <div className="tab_content_wrapper"><span className="content_heading">Basic Details</span></div>
                                <table className="table table-hover table-borderless">
                                    <tbody>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Item Category </td>
                                            <td className="details-name" style={{ "width": "66%" }}>{this.state.itemData?.category_display}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Item Name</td>
                                            <td className="details-name">{this.state.itemData?.name}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Item Code</td>
                                            <td className="details-name">{this.state.itemData?.item_code ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Item Number</td>
                                            <td className="details-name">{this.state.itemData?.item_number ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Item Status</td>
                                            <td className="details-name">{this.state.itemData && this.state.itemData.status ? <Status color={this.state.itemData.status_color}>{this.state.itemData.status_text}</Status> : ""}</td>
                                        </tr>

                                        <tr>
                                            <td className="details-label">Item Description</td>
                                            <td className="details-name">{this.state.itemData?.description ?? ''}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Unit of Measurement</td>
                                            <td className="details-name">{this.state.itemData?.measuring_unit?.name ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Manufacturer</td>
                                            <td className="details-name">{this.state.itemData?.manufacturer?.name ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Manufacturer Part Number (MPN)</td>
                                            <td className="details-name">{this.state.itemData?.manufacturer_part_no ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >Item Tags</td>
                                            <td className="details-name" >
                                                {
                                                    this.state.itemData?.tags?.length > 0
                                                        ? (this.state.itemData?.tags.map((item, k) => <span key={k} className="badge bg-secondary">{item.name}</span>))
                                                        : '-'
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >HSN / SAC Code</td>
                                            <td className="details-name" >{this.state.itemData?.hsn_code ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >Generate Scrap on Replacement</td>
                                            <td className="details-name" >{this.state.itemData?.is_scrapble == 'N' ? 'NO' : 'Yes' ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >Created On</td>
                                            <td className="details-name" >{this.state.itemData?.created_at_display ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >Created By</td>
                                            <td className="details-name" >{this.state.itemData && this.state.itemData.created_user ? this.state.itemData.created_user.full_name : '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >Updated On</td>
                                            <td className="details-name" >{this.state.itemData?.updated_at_display ?? '-'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" >Updated By</td>
                                            <td className="details-name" >{this.state.itemData && this.state.itemData.updated_user ? this.state.itemData.updated_user.full_name : '-'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="tab_content_wrapper"><span className="content_heading">Pricing</span></div>
                                <table className="table table-hover table-borderless">
                                    <tbody>

                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Purchase Price</td>
                                            <td className="details-name" style={{ "width": "66%" }}>{this.state.itemData.purchase_currency && this.state.itemData?.purchase_currency} {this.state.itemData?.purchase_price ?? ''}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">Sale / Consumption Price</td>
                                            <td className="details-name">{this.state.itemData.consumption_currency && this.state.itemData?.consumption_currency} {this.state.itemData?.consumption_price ?? ''}</td>
                                        </tr>
                                        {this.state.itemData?.is_scrapble === "Y" ? <tr>
                                            <td className="details-label">Scrap Price</td>
                                            <td className="details-name">{this.state.itemData?.scrap_price ?? ''}</td>
                                        </tr> : null}
                                    </tbody>
                                </table>
                                <div className="tab_content_wrapper"><span className="content_heading">Taxation</span></div>
                                <table className="table table-hover table-borderless">
                                    <tbody>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Tax Status </td>
                                            <td className="details-name" style={{ "width": "66%" }}>{this.state.itemData?.is_taxable == 'Y' ? 'Taxable' : 'Non - Taxable'}</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">IGST Percentage</td>
                                            <td className="details-name">{this.state.itemData?.igst ?? 0}%</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">CGST Percentage</td>
                                            <td className="details-name">{this.state.itemData?.cgst ?? 0}%</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label">SGST Percentage</td>
                                            <td className="details-name">{this.state.itemData?.sgst ?? 0}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                                {this.state.itemData && this.state.itemData.category === "services" ? null
                                    : (
                                        <div style={{marginBottom:"80px"}}>
                                            <div className="tab_content_wrapper "><span className="content_heading">Opening Balance</span></div>
                                        <table className="table table-hover table-bordered mt-2 mb-5">
                                            <thead className="table-secondary">
                                                <tr>
                                                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                                                    <th scope="col" className="text-start" style={{ width: "25%" }}>Warehouse</th>
                                                    <th scope="col" className="text-center" style={{ width: "10%" }}>Quantity</th>
                                                    <th scope="col" className="text-center" style={{ width: "15%" }}>Unit Rate</th>
                                                    <th scope="col" className="text-end" style={{ width: "15%" }}>Amount</th>
                                                    {this.props.isc_configuration?.track_batch_expiry == "Y" ? (
                                                        <Ax>
                                                            <th scope="col" className="text-start" style={{ width: "15%" }}>Batch Number</th>
                                                            <th scope="col" className="text-center" style={{ width: "10%" }}>Expiry Date</th>
                                                        </Ax>)
                                                        : null}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.itemData && this.state.itemData.opening_stock && this.state.itemData.opening_stock.length > 0 ?
                                                    this.state.itemData.opening_stock.map((a, k) => (<tr key={k} className='text-center'>
                                                        <td>{k + 1}</td>
                                                        <td className="text-start">{a.warehouse.name}</td>
                                                        <td>{a.qty}</td>
                                                        <td >{a.rate}</td>
                                                        <td className="text-end">{a.qty * a.rate}</td>
                                                        {this.props.isc_configuration?.track_batch_expiry == "Y" ? (
                                                            <Ax>
                                                                <td className='text-start'>{a.batch_number ?? "-"}</td>
                                                                <td>{a.expiry_date ? moment(a.expiry_date).format("DD-MMM-YYYY") : "-"}</td>
                                                            </Ax>)
                                                            : null}
                                                    </tr>))
                                                    : <tr><td colSpan={7} className='text-center'>No Record</td> </tr>}
                                            </tbody>
                                        </table>
                                        </div>
                                    )}
                            </div>
                        ) : null}
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => ({
    access_token: state.auth.access_token,
    isc_configuration: state.app?.isc_configuration || null
});

export default connect(mapStateToProps)(ItemDetailsTab);